import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import { ROUTES } from "../constants";

export default function PrivateRoute({ children }) {
  const { isAuthenticated, isCheckingAuth } = useAuthContext();

  if (isCheckingAuth) {
    return null;
  }

  return isAuthenticated ? children : <Navigate to={ROUTES.LOGIN} replace />;
}
